import { userToast } from 'helpers/toastMessages';

export const headerData = {
  tableName: 'Groups',
  hasExport: false,
  hasSearch: true,
  hasDelete: true,
  hasEdit: true,
  hasPaging: true,
  hasCheckbox: false,
  hasUploadCSV: false,
  hasLock: true,
  hasAddMembers: true,
  deleteSubtext: 'Are you sure you want to delete this user group?',
  fields: [
    {
      fieldName: 'groupName',
      headerName: 'Group Name',
      fontWeight: 500,
    },
    {
      fieldName: 'description',
      headerName: 'Description',
    },
    {
      fieldName: 'role',
      headerName: 'Role',
      hasTag: true,
    },
    {
      fieldName: 'members',
      headerName: 'Members',
    },
    {
      fieldName: 'createdOn',
      headerName: 'Created',
      isDatetime: true,
    },
  ],
};
